import ConfirmModal from "../modal/ConfirmModal";
import {UserPermission} from "./types";
import {deleteUserPermission} from "./service";
import {setErrorNotificationText, setSuccessNotificationText} from "../notification/slice";
import {useAppDispatch} from "../../app/hooks";

interface DeletePermissionProps {
    closeAction: CallableFunction
    confirmAction: CallableFunction
    permission: UserPermission
}

export const DeletePermissionModal = (props :DeletePermissionProps) => {

    const dispatch = useAppDispatch();

    const handleDeletePermission = () => {
        deleteUserPermission(props.permission).then(res => {
            dispatch(setSuccessNotificationText('Permission deleted successfully'));
            props.confirmAction();
            props.closeAction();
        }).catch(() => {
            dispatch(setErrorNotificationText('Permission not deleted'));
            props.closeAction();
        })
    }

    return (
        <ConfirmModal title={"Delete User Permission"} onClose={props.closeAction} onConfirm={handleDeletePermission}>
            Are you sure you want to delete {
            props.permission.resource.map((resource, index) => {
                const comma = ((index + 1) !== props.permission.resource.length) ? ', ': '';
                return (resource[0].toUpperCase() + resource.substring(1) + comma)
            })} permissions
        </ConfirmModal>
    )
}

export default DeletePermissionModal;